import RecognizedRibbon from '../../src/legacy/RecognizedRibbon';
export default RecognizedRibbon;
